import type {Department, ViewableSettingChain} from 'typings/portaro.be.types';
import type {SettingsService} from './settings.service';
import type {Component} from 'typings/portaro.fe.types';
import {transferify} from 'shared/utils/data-service-utils';
import type {IOnInit} from 'angular';
import type {ViewableSettingValue} from 'typings/portaro.be.types';
import KpValueEditor from '../../commons/value-editors/kp-value-editor/KpValueEditor.svelte';
import KpDatatypedValue from '../../commons/components/kp-datatyped/KpDatatypedValue.svelte';

export interface ChainItemWithState extends ViewableSettingValue {
    state?: State;
    temporary?: boolean;
}

export enum State {
    NORMAL = 'NORMAL',
    EDITING = 'EDITING',
    PROCESSING = 'PROCESSING'
}

interface SettingsItemComponentBindings {
    setting: ViewableSettingChain;
}

export default class SettingsItemComponent implements Component<SettingsItemComponentBindings> {
    static componentName = 'settingsItem';

    public templateUrl = require('./settings-item.tpl.ftl');
    bindings = {
        setting: '<'
    } as const;
    controller = SettingsItemComponentController;
}


class SettingsItemComponentController implements SettingsItemComponentBindings, IOnInit {
    public static presenterName = 'settingsItemComponentController';

    public kpValueEditorComponent = KpValueEditor;
    public kpDatatypedValue = KpDatatypedValue;

    public State = State;
    public setting: ViewableSettingChain;

    /*@ngInject*/
    constructor(private CONTEXT_PATH: string, private settingsService: SettingsService, private currentDepartment: Department) {
    }

    public $onInit() {
        this.setToNormalState(this.setting);
    }


    public edit(chainItem: ChainItemWithState) {
        chainItem.state = (chainItem.state === State.NORMAL ? State.EDITING : State.NORMAL);
    }

    public async deleteCustom(chainItem: ChainItemWithState) {
        chainItem.state = State.PROCESSING;
        try {
            const savedSetting = await this.settingsService.deleteSettings(chainItem.id);
            Object.assign(this.setting, savedSetting);
        } finally {
            this.setToNormalState(this.setting);
        }
    }

    public async saveCustom(chainItem: ChainItemWithState) {
        chainItem.state = State.PROCESSING;
        const transferable = this.getTransferable(this.setting, chainItem);
        try {
            const savedSetting = await this.settingsService.saveSettings(transferable)
            Object.assign(this.setting, savedSetting);
        } finally {
            this.setToNormalState(this.setting);
        }
    }

    public override(chainItem: ChainItemWithState) {
        const lastOfChain: ChainItemWithState = this.setting.chain[this.setting.chain.length - 1];

        if (lastOfChain.temporary) {
            this.edit(lastOfChain);
        } else {
            this.setting.chain.push({
                id: null,
                editable: true,
                overridable: false,
                department: this.currentDepartment,
                fond: null,
                note: null,
                value: chainItem.value,
                // @ts-ignore i dont know why
                temporary: true,
                state: State.EDITING
            });
        }
    }

    private setToNormalState(settings: ViewableSettingChain) {
        settings.chain.forEach((setting: ChainItemWithState) => {
            setting.temporary = false;
            setting.state = State.NORMAL;
        });
    }

    private getTransferable(richSetting: ViewableSettingChain, chainItem: ChainItemWithState) {
        const transferableValue = transferify(chainItem.value, true);
        return {
            section: richSetting.section,
            name: richSetting.name,
            departmentId: chainItem.department && chainItem.department.id,
            fondId: chainItem.fond && chainItem.fond.id,
            value: Array.isArray(transferableValue) ? transferableValue.join(',') : transferableValue,
            note: chainItem.note
        };
    }


}